import React from 'react';
import { Box, Responsive, StackLayout } from '@leagueplatform/genesis-core';
import { Masonry } from '@leagueplatform/masonry';
import {
  MasonryGetCareLeftRootNodeId,
  MasonryGetCareRightRootNodeId,
  MasonryGetCareMobileRootNodeId,
} from 'config/get-care-page.config';

// Nudge the right column down so the "Wellness Tips" heading lines up with the
// left column "Find the right care" header. Tune this value if needed. CIG-10988.
const RIGHT_COLUMN_TOP_OFFSET = '40px';

export const GetCareLayout: React.FC = () => (
  <>
    {/* Mobile Layout: single column */}
    <Responsive down="tablet">
      <Box css={{ width: '100%' }}>
        <Masonry rootNodeId={MasonryGetCareMobileRootNodeId} />
      </Box>
    </Responsive>

    {/* Desktop Layout: left sections + right Wellness Tips */}
    <Responsive up="tablet">
      <StackLayout
        orientation="horizontal"
        spacing={{
          '@initial': '$twoAndHalf',
          '@desktop': '$twoAndHalf',
          '@laptop': '$twoAndHalf',
          '@tablet': '$oneAndHalf',
          '@mobileLandscape': '$oneAndHalf',
        }}
      >
        <Box css={{ width: '100%' }} id="left-column">
          <Masonry rootNodeId={MasonryGetCareLeftRootNodeId} />
        </Box>
        <Box
          css={{ marginTop: RIGHT_COLUMN_TOP_OFFSET, maxWidth: '326px' }}
          id="right-column"
        >
          <Masonry rootNodeId={MasonryGetCareRightRootNodeId} />
        </Box>
      </StackLayout>
    </Responsive>
  </>
);
